module.exports = __webpack_public_path__ + "img/berechnung_option_2.14f23c28.png";